import {
  AssistantChatAction,
  AssistantChatBlock,
  AssistantChatHighlight,
  AssistantChatPoint,
} from '../../interfaces/assistant-chat.interface';

export function wellFormedBlocks(blocks: unknown): AssistantChatBlock[] {
  return listOf(blocks)
    .filter(block => typeof block?.type === 'string')
    .map(block => wellFormed(block));
}

function wellFormed(block: any): AssistantChatBlock {
  const shaped = withTitleIfText(block);
  switch (block.type) {
    case 'text':
    case 'draft':
      return { ...shaped, body: textOf(block.body) };
    case 'table':
      return {
        ...shaped,
        columns: listOf(block.columns).map(textOf),
        rows: listOf(block.rows).map(row => listOf(row).map(textOf)),
      };
    case 'points':
      return { ...shaped, items: listOf(block.items).map(pointOf) };
    case 'highlights':
      return { ...shaped, items: listOf(block.items).map(highlightOf) };
    case 'working':
    case 'followups':
      return { ...shaped, items: listOf(block.items).map(textOf).filter(item => !!item) };
    case 'actions':
      return { ...shaped, items: listOf(block.items).filter(isAction) };
    default:
      return shaped;
  }
}

function pointOf(point: any): AssistantChatPoint {
  return { ...withTitleIfText(point), body: textOf(point?.body) };
}

function highlightOf(item: any): AssistantChatHighlight {
  const highlight: AssistantChatHighlight = { label: textOf(item?.label), value: textOf(item?.value) };
  return item?.context === undefined ? highlight : { ...highlight, context: textOf(item.context) };
}

function isAction(action: any): action is AssistantChatAction {
  return typeof action?.id === 'string' && typeof action?.label === 'string';
}

function withTitleIfText(value: any): any {
  const { title, ...rest } = value || {};
  return typeof title === 'string' ? { ...rest, title } : rest;
}

function listOf(value: unknown): any[] {
  return Array.isArray(value) ? value : [];
}

function textOf(value: unknown): string {
  return typeof value === 'string' || typeof value === 'number' ? String(value) : '';
}
